import React from 'react';
import PropTypes from 'prop-types';
import styles from './IntroduccioIndividuFenofasesDetallOpcions.module.css';
import IntroduccioIndividuFenofasesDetallValor from './IntroduccioIndividuFenofasesDetallValor';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import {
  VALOR_FENOFASE_OBSERVADA,
  VALOR_FENOFASE_NO_OBSERVADA,
  VALOR_FENOFASE_DUBTE,
} from '../../constantsObservacions';
import {
  fetchCrearObservacio,
  fetchCanviObservacio,
  fetchEsborrarObservacio,
} from '../../actions/consultesServidor';
import { NotificacioError } from '../Notification';
import {
  obtenirDadesIntroduccio,
  esborrarComentaris,
  errorConsultaServidor,
} from '../../actions';
import { getUsuari } from '../../reducers';
import configuracio from '../../configuracioEntorns';
import { MISSATGE_USUARI_NO_ACTIU } from '../../constantsFormularis';

class IntroduccioIndividuFenofasesDetallOpcions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      creacioObservacioEnCurs: false,
      usuariNoActiu: false,
    };
  }

  gestioError = (error, titolTipus) => {
    if (error === MISSATGE_USUARI_NO_ACTIU) {
      this.gestioUsuariNoActiu(error);
    } else {
      this.gestioErrorPerTipus(error, titolTipus);
    }
  };

  gestioUsuariNoActiu = (error) => {
    this.setState({ creacioObservacioEnCurs: false, usuariNoActiu: true });
    this.props.errorConsultaServidor(error, MISSATGE_USUARI_NO_ACTIU);
  };

  gestioErrorPerTipus = (error, titolTipus) => {
    const { onDisableComponent } = this.props;
    this.setState({ creacioObservacioEnCurs: false });
    onDisableComponent(false);
    this.props.errorConsultaServidor(error, titolTipus);
    this.props.obtenirDadesIntroduccio();
  };

  gestioExit = (observacio, tipus) => {
    const { onDisableComponent } = this.props;
    onDisableComponent(false);
    this.props.obtenirDadesIntroduccio();
    this.setState({ creacioObservacioEnCurs: false });
    if (observacio && observacio.message && observacio.titol) {
      NotificacioError(observacio.titol, observacio.message);
    }
    if (tipus === 'D') {
      const { observacioActual } = this.props;
      this.props.esborrarComentaris(observacioActual.idIndividuFenofase, true);
    }
  };

  handleObservacio = (valorNou) => {
    const { fenofase, observacioActual, data, onDisableComponent } = this.props;
    const idFenofase = fenofase.idFenofase;
    const idIndividu = fenofase.fenofaseIdIndividu;
    const idObservacio = observacioActual.idObservacion
      ? observacioActual.idObservacion
      : null;
    const esBaixa = observacioActual.valorActual === valorNou ? true : false;

    this.setState({ creacioObservacioEnCurs: true });

    onDisableComponent(true);

    if (idObservacio) {
      if (esBaixa) {
        fetchEsborrarObservacio(idObservacio, this.props.usuari).then(
          (observacio) => {
            this.gestioExit(observacio, 'D');
          },
          (error) => {
            this.gestioError(error, 'Error esborrant observació.');
          }
        );
      } else {
        fetchCanviObservacio(idObservacio, valorNou, this.props.usuari).then(
          (observacio) => {
            this.gestioExit(observacio);
          },
          (error) => {
            this.gestioError(error, 'Error canviant observació.');
          }
        );
      }
    } else {
      fetchCrearObservacio(
        idIndividu,
        idFenofase,
        data,
        valorNou,
        this.props.usuari
      ).then(
        (observacio) => {
          this.gestioExit(observacio);
        },
        (error) => {
          this.gestioError(error, 'Error creant observació.');
        }
      );
    }
  };

  // Render the child component and set the action property with the handler as value
  render() {
    const { usuariNoActiu } = this.state;

    if (usuariNoActiu) {
      const urlBase = configuracio.ruta;
      return <Redirect to={`${urlBase}/login`} />;
    }

    const { observacioActual } = this.props;
    return (
      <div className={styles.opcions}>
        <IntroduccioIndividuFenofasesDetallValor
          type={'check'}
          valorDefecte={VALOR_FENOFASE_OBSERVADA}
          observacioActual={observacioActual}
          handleObservacio={this.handleObservacio}
        />
        <IntroduccioIndividuFenofasesDetallValor
          type={'close'}
          valorDefecte={VALOR_FENOFASE_NO_OBSERVADA}
          observacioActual={observacioActual}
          handleObservacio={this.handleObservacio}
        />
        <IntroduccioIndividuFenofasesDetallValor
          type={'question'}
          valorDefecte={VALOR_FENOFASE_DUBTE}
          observacioActual={observacioActual}
          handleObservacio={this.handleObservacio}
        />
      </div>
    );
  }
}

IntroduccioIndividuFenofasesDetallOpcions.propTypes = {
  fenofase: PropTypes.object.isRequired,
  observacioActual: PropTypes.object.isRequired,
  obtenirDadesIntroduccio: PropTypes.func.isRequired,
  esborrarComentaris: PropTypes.func.isRequired,
  errorConsultaServidor: PropTypes.func.isRequired,
  onDisableComponent: PropTypes.func.isRequired,
  usuari: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    data: state.introduccio ? state.introduccio.data : {},
    usuari: getUsuari(state),
  };
};

const mapDispatchToProps = {
  obtenirDadesIntroduccio,
  errorConsultaServidor,
  esborrarComentaris,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IntroduccioIndividuFenofasesDetallOpcions);
